import type { ZypeSubscription } from "@inferno/renderer-shared-core";

export function getPlanIntervalInMonths({ interval, interval_count }: { interval: string; interval_count: number }) {
  return interval_count * (interval === "year" ? 12 : 1);
}

export const isGiftSubscription = (s: ZypeSubscription) => s.plan_name.startsWith("Gift");

export const isSubscriptionCanceled = (s: ZypeSubscription) => s.status === "canceled";

export const canCancelSubscription = (s: ZypeSubscription) => !isSubscriptionCanceled(s) && !isGiftSubscription(s);

export const canReactivateSubscription = (s: ZypeSubscription) => isSubscriptionCanceled(s) && !isGiftSubscription(s);

export const getSubscriptionDisplayStatus = (s: ZypeSubscription) => {
  if (isGiftSubscription(s)) {
    return "";
  }

  return isSubscriptionCanceled(s) ? " (Canceled)" : " (Auto-Renewal)";
};

export const getUserSettingsLoaderCacheKey = (accessToken: string | null) => `coast-user-settings-${accessToken}`;
